import router from '@/router';
import { getToken } from '@/utils/auth'
import store from '@/store'
import { Message } from 'element-ui'

const whiteList = ['/','/public','/search','/post','/essay','/401','/404',"/rss"]

router.beforeEach((to, from, next) => {
  if (getToken()) {
    /* has token*/
    if(store.getters.loginFlag){
      next()
    }else {
      store.dispatch('getInfo').then(() => {
        next({ ...to, replace: true })
      }).catch((err)=>{
        store.dispatch('logout').then(() => {
          Message.error(err)
          next({ path: '/' })
        })
      })
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next(`/`) // 否则全部重定向到登录页
    }
  }
});
